export default "__VITE_ASSET__COjWGfK0__"